// src/pages/TermsPage.tsx
import React from 'react';
import { Container, Typography } from '@mui/material';

const TermsPage: React.FC = () => (
    <Container maxWidth="md">
        <Typography variant="h4" component="h1" gutterBottom>Terms of Service</Typography>
        <Typography variant="body1">
            Welcome to LaiaTools. By using our services, you agree to these terms. Please read them carefully.
            Content for the Terms of Service will be placed here.
        </Typography>
    </Container>
);

export default TermsPage;